import { render, staticRenderFns } from "./Team1Demo.vue?vue&type=template&id=c8b9768a&"
import script from "./Team1Demo.vue?vue&type=script&lang=js&"
export * from "./Team1Demo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports